export type Step2PhoneState =
  | "S2_CHOICE"
  | "S2_OWN_FORM"
  | "S2_OWN_SMS_CODE"
  | "S2_OWN_SMS_FAILED"
  | "S2_OWN_WHATSAPP_CHECK"
  | "S2_OWN_WHATSAPP_FAILED"
  | "S2_OWN_SUCCESS"
  | "S2_VUELVE_PICK"
  | "S2_DONE";

export type Step2MessageType =
  | "whatsapp_choice"
  | "whatsapp_own_form"
  | "whatsapp_own_sms_code"
  | "whatsapp_own_sms_failed"
  | "whatsapp_own_whatsapp_check"
  | "whatsapp_own_whatsapp_failed"
  | "whatsapp_own_success"
  | "whatsapp_vuelve_pick"
  | "whatsapp_meta";

export const STEP2_MESSAGE_TYPES: Step2MessageType[] = [
  "whatsapp_choice",
  "whatsapp_own_form",
  "whatsapp_own_sms_code",
  "whatsapp_own_sms_failed",
  "whatsapp_own_whatsapp_check",
  "whatsapp_own_whatsapp_failed",
  "whatsapp_own_success",
  "whatsapp_vuelve_pick",
  "whatsapp_meta",
];

export const isStep2MessageType = (type?: string): type is Step2MessageType =>
  Boolean(type && STEP2_MESSAGE_TYPES.includes(type as Step2MessageType));
